import { render, staticRenderFns } from "./newDocument.vue?vue&type=template&id=4c99c037&"
import script from "./newDocument.vue?vue&type=script&lang=js&"
export * from "./newDocument.vue?vue&type=script&lang=js&"
import style0 from "./newDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
